export const myAccount = {
  closeAccount: {
    confirmAccountClosure: 'Confirm Account Closure',
    confirmAccountClosureMessage: 'Are you sure you want to close your account?',
    closeMyAccount: 'CLOSE MY ACCOUNT',
    accountClosedSuccessfully: 'Account closed successfully',
    accountClosedFailure: 'Failed to close the account',
  },
  updatePasswordForm: {
    oldPassword: {
      label: 'Old Password',
      placeholder: 'Enter your Password',
    },
    oldPasswordIsRequired: 'Old password is required.',
    newPassword: {
      label: 'New Password',
      placeholder: 'Enter your new Password',
    },
    passwordMinRequirements:
      'Here’s a quick guide for a secure password: must have 8 to 16 characters, including at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character..',
    confirmPassword: {
      label: 'Confirm New Password',
      placeholder: 'Re-enter your new password',
    },
    bothPasswordMustMatch: 'Both passwords must match',
    passwordUpdateSuccess: 'Password updated successfully',
    accessDeniedError: 'Access denied',
  },
  updateProfileForm: {
    title: 'Title',
    none: '',
    firstName: {
      label: 'First Name',
      placeholder: 'First Name',
    },
    firstNameIsRequired: 'First name is required.',
    lastName: {
      label: 'Last Name',
      placeholder: 'Last Name',
    },
    lastNameIsRequired: 'Last name is required.',
    profileUpdateSuccess: 'Profile updated successfully.',
    customerId: 'Email',
  },
  consentManagementForm: {
    clearAll: 'Clear All',
    selectAll: 'Select All',
    message: {
      success: {
        given: 'Consent successfully given.',
        withdrawn: 'Consent successfully withdrawn.',
      },
    },
  },
  myCoupons: {
    noCouponsMessage: 'You have no available coupons.',
    effectiveTitle: 'Valid:',
    Effective: 'VALID',
    PreSession: 'VALID SOON',
    ExpireSoon: 'EXPIRING SOON',
    readMore: 'Read More',
    notification: 'Notification',
    findProducts: 'Find Products',
    status: 'Status:',
    dialogTitle: 'Coupon',
    claimCustomerCoupon: 'You have successfully claimed this coupon.',
    myCoupons: 'My Coupons',
    startDateAsc: 'Start Date (ascending)',
    startDateDesc: 'Start Date (descending)',
    endDateAsc: 'End Date (ascending)',
    endDateDesc: 'End Date (descending)',
    sortBy: 'Sort By',
    sortCoupons: 'Sort Coupons',
    notesPreffix: 'You can set your preferred channels for receiving coupon notifications on the ',
    notesLink: 'Notification Channels',
    notesSuffix: '.',
  },
  notificationPreference: {
    message: 'Select your preferred notification channels',
    note: 'Note: ',
    noteMessage: 'If you disable all channels, you will no longer receive notifications.',
    EMAIL: 'Email:',
    SMS: 'SMS:',
    SITE_MESSAGE: 'Site Message',
  },
  myInterests: {
    header: 'My Interests',
    item: 'ITEM',
    price: 'PRICE',
    notifications: 'NOTIFICATIONS',
    noInterests: 'You currently have no registered interests.',
    inStock: 'In Stock',
    lowStock: 'Low Stock',
    outOfStock: 'Out of Stock',
    BACK_IN_STOCK: 'Back in Stock',
    sortBy: 'Sort By',
    sortInterests: 'Sort Interests',
    expirationDate: ' - Until {{ expirationDate }}',
    productId: 'ID {{ code }}',
    remove: 'Remove',
    sorting: {
      byNameAsc: 'Name (ascending)',
      byNameDesc: 'Name (descending)',
    },
    actions: 'ACTIONS',
    caption: 'Contents of My Interests.',
    itemRemoved: 'The selected item has been removed.',
  },
  navMenu: {
    account: 'Account',
    myAccount: 'My Account',
    address: 'Shipping Address',
    change: 'Change',
  },
  quoteHistory: {
    quoteTable: {
      quoteNumber: 'Quote Number',
      quoteName: 'Quote Name',
      finalCustomer: 'Final Customer',
      location: 'Location',
      status: 'Status',
      approvalDate: 'Approval Date',
      expirationDate: 'Expiration Date',
    },
    form: {
			instructions: 'Use the fields below to search for quotes by date range.',
      from: 'From',
      to: 'To',
      search: 'Search',
    },
  },
};
